const locale = {
  placeholder: 'സമയം തിരഞ്ഞെടുക്കുക',
  rangePlaceholder: ['ആരംഭ സമയം', 'അവസാന സമയം']
};
export default locale;